import { CheckCircle2 } from 'lucide-react';

/**
 * The tri-state task/step circle: blank outline → green pie fill as
 * progress grows → full check when done. A FILL AMOUNT instead of shade
 * steps: readable at 15px, in dark mode, and with color-vision deficiency —
 * and it shows real progress, not just quartiles.
 */
export function ProgressCircle({
  progress,
  done,
  size,
}: {
  /** 0..1 derived progress (ignored when done). */
  progress: number;
  done: boolean;
  size: number;
}) {
  if (done) {
    return <CheckCircle2 size={size} className="text-emerald-600 dark:text-emerald-400" />;
  }
  const p = Math.max(0, Math.min(1, progress));
  const r = 7;
  const c = 2 * Math.PI * r;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      role="img"
      aria-label={p > 0 ? `${Math.round(p * 100)}% done` : 'Not started'}
    >
      <circle
        cx="9"
        cy="9"
        r={r}
        fill="none"
        strokeWidth="1.6"
        className={p > 0 ? 'stroke-emerald-500/40' : 'stroke-current'}
      />
      {p > 0 && (
        <circle
          cx="9"
          cy="9"
          r={r}
          fill="none"
          strokeWidth="3.2"
          strokeDasharray={`${c * p} ${c}`}
          strokeLinecap="round"
          transform="rotate(-90 9 9)"
          className="stroke-emerald-500 dark:stroke-emerald-400"
        />
      )}
    </svg>
  );
}
